/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { theme, SVGIcon, FlexContainer } from "@nordcloud/gnui";

export const OptionsWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

export const StyledOptions = styled.div`
  max-height: 12rem;
  overflow-y: auto;
  top: 2.25rem;
  left: 0;
  position: absolute;
  font-size: ${theme.fontSizes.sm};
  line-height: ${theme.spacing.spacing04};
  padding: ${theme.spacing.spacing02};
  padding-bottom: ${theme.spacing.spacing01};
  background-color: ${theme.color.background.ui01};
  color: ${theme.color.text.text01};
  border-radius: ${theme.radius.md};
  z-index: ${theme.zindex.sticky};
  opacity: 0;
  box-shadow: ${theme.shadow.shadow02};
  animation: 0.2s ease-in-out both fadeInUp;
  @keyframes fadeInUp {
    from {
      transform: translate3d(0, -8px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
`;

export const StyledOption = styled(FlexContainer)`
  min-width: 9rem;
  max-width: 19rem;
  padding: ${theme.spacing.spacing01} ${theme.spacing.spacing02};
  border-radius: ${theme.radius.md};
  margin-bottom: ${theme.spacing.spacing01};

  &:hover {
    cursor: pointer;
    background-color: ${theme.color.background.ui04};
  }

  & * {
    pointer-events: none;
  }
`;

export const OptionIcon = styled(SVGIcon)`
  width: ${theme.spacing.spacing03};
  height: ${theme.spacing.spacing03};
`;
